import Button from "@rio-cloud/rio-uikit/Button";
import TableSettingsDialog from "@rio-cloud/rio-uikit/TableSettingsDialog";
import TableViewToggles, { type TableViewTogglesViewType } from "@rio-cloud/rio-uikit/TableViewToggles";
import { useT } from "@hooks";
import type { ColumnDetails, ColumnDetailsMap, ColumnLabel, ToolbarViewType } from "./toolbarTypes";

export interface ToolbarActionsProps {
  viewType: ToolbarViewType;
  showTableSettingsDialog: boolean;
  defaultColumnOrder: string[];
  defaultHiddenColumns?: string[];
  columnOrder: string[];
  hiddenColumns: string[];
  columnLabels: ColumnLabel;
  disabledColumns: string[];
  columnsDetails: ColumnDetailsMap;
  handleViewTypeChange: (newViewType: TableViewTogglesViewType) => void;
  handleToggleTableSettingsDialog: () => void;
  handleColumnChange: (
    newColumnOrder: string[],
    newHiddenColumns: string[],
    newColumnsDetails?: ColumnDetailsMap
  ) => void;
  handleColumnDetailsChange: (column: string, newColumnDetails: ColumnDetails) => void;
  handleRefresh: () => void;
  handleDownload: () => void;
}

const ToolbarActions = ({
  viewType,
  showTableSettingsDialog,
  defaultColumnOrder,
  defaultHiddenColumns = [],
  columnOrder,
  columnLabels,
  hiddenColumns,
  disabledColumns,
  columnsDetails,
  handleViewTypeChange,
  handleToggleTableSettingsDialog,
  handleColumnChange,
  handleColumnDetailsChange,
  handleRefresh,
  handleDownload,
}: ToolbarActionsProps) => {
  const t = useT();

  return (
    <>
      <div className="table-toolbar-group-right">
        <div className="table-toolbar-column table-toolbar-column-spacer">
          <TableViewToggles
            initialViewType={viewType}
            className="rounded-small"
            onViewTypeChange={handleViewTypeChange}
            tableViewTooltipContent={t("table.toggle.table")}
            singleCardViewTooltipContent={t("table.toggle.list")}
            multiCardsViewTooltipContent={t("table.toggle.cards")}
          />
        </div>
        <div className="table-toolbar-column">
          <div className="btn-group rounded-small">
            <Button iconOnly iconName="rioglyph rioglyph-refresh" onClick={handleRefresh} />
            <Button iconOnly iconName="rioglyph rioglyph-download" onClick={handleDownload} />
            <Button iconOnly iconName="rioglyph rioglyph-cog" onClick={handleToggleTableSettingsDialog} />
          </div>
        </div>
      </div>

      {showTableSettingsDialog && (
        <TableSettingsDialog
          show={showTableSettingsDialog}
          title={t("table.settings.title")}
          onHide={handleToggleTableSettingsDialog}
          onColumnChange={handleColumnChange}
          defaultColumnOrder={defaultColumnOrder}
          defaultHiddenColumns={defaultHiddenColumns}
          columnOrder={columnOrder}
          hiddenColumns={hiddenColumns}
          columnLabels={columnLabels}
          disabledColumns={disabledColumns}
          closeButtonText={t("table.settings.close")}
          resetButtonText={t("table.settings.reset")}
          searchPlaceholder={t("table.settings.columnName")}
          notFoundMessage={t("table.settings.noColumns")}
          columnsDetails={columnsDetails}
          autoLabel={t("table.settings.auto")}
          onColumnDetailsChange={handleColumnDetailsChange}
          onSearchChange={(val: string) => console.log(val)}
          immediateChange
        />
      )}
    </>
  );
};

export default ToolbarActions;
